import { defineStore } from 'pinia'
import { isEmpty } from 'lodash'

import { api } from '@/services'
import authConstants from '@/constants/auth'
import { usePlatformAuthStore } from '@/stores/platformAuth'
import { useAuthHelpers } from '@/composables'

export const usePlatformAuthBasicStore = defineStore('platform-auth-basic', {
    actions: {
        login({ url, username, password }) {
            const authHelpers = useAuthHelpers()
            const platformAuthStore = usePlatformAuthStore()

            return api.post(url, {
                username,
                password,
            })
                .then((response) => {
                    authHelpers.handleUserContextChange(response.data)
                    platformAuthStore.events.emit('login', {
                        userSwitched: !isEmpty(response.headers[authConstants.LoginHeaders.userSwitched]),
                    })
                })
                .catch((error) => {
                    platformAuthStore.events.emit('error', error)
                    throw error
                })
        },
    },
})
